import type { CmsProps } from '../../types/cms'
import styled from '@emotion/styled'
import { Background } from '../surfaces/background'

export const ProductVariantPanelContainer = styled(Background)<CmsProps>`
  text-align: center;

  h2 {
    margin-bottom: 1rem;
  }

  a {
    color: ${({ theme }) => theme.palette.primary.light};
    text-decoration: underline;
  }
`
